(ns ductile.ui.load-builder-v2.state
  (:require [clojure.set :as set]))

(defn id->index [ids]
  (into {} (map-indexed (fn [idx id] [id idx]) ids)))

(defn range-selection [ids anchor-id current-id]
  (let [idx (id->index ids)
        a (get idx anchor-id)
        b (get idx current-id)]
    (if (and (number? a) (number? b))
      (let [from (min a b)
            to (max a b)]
        (set (subvec (vec ids) from (inc to))))
      #{current-id})))

(defn click-selection
  [{:keys [selected-ids anchor-id]} {:keys [row-id ordered-ids toggle? shift?]}]
  (let [selected-ids (set selected-ids)
        selected? (contains? selected-ids row-id)]
    (cond
      shift?
      {:selected-ids (range-selection ordered-ids (or anchor-id row-id) row-id)
       :anchor-id anchor-id}

      toggle?
      {:selected-ids (if selected?
                       (disj selected-ids row-id)
                       (conj selected-ids row-id))
       :anchor-id row-id}

      selected?
      {:selected-ids (disj selected-ids row-id)
       :anchor-id (when-not (= anchor-id row-id) anchor-id)}

      :else
      {:selected-ids #{row-id}
       :anchor-id row-id})))

(defn drag-selection
  [{:keys [selected-ids anchor-id]} {:keys [row-keys append?]}]
  (let [row-keys (set row-keys)]
    {:selected-ids (if append?
                     (set/union (set selected-ids) row-keys)
                     row-keys)
     :anchor-id (if (seq row-keys) (first row-keys) anchor-id)}))
